// extracted by mini-css-extract-plugin
export default {"Properties":"CUi3AbIens3sL3s5Iv_U"};